
$(document).ready(function() {

  var elem = document.querySelector("#modalRestablecerAcceso");
  if (elem == null) {
    return;
  }

  $("#modalRestablecerAcceso").modal("show");

  if($('#modalRestablecerAcceso form')[0] == null){
    window.history.pushState({}, null, "/");
  }

  $('#modalRestablecerAcceso form').validarForm((form) => {

    $("#btnRestablecer").loader("show")

    var formData = new FormData(form)
    axios
      .post('/actualizar-acceso', formData)
      .then((respuesta) => {
        $("#btnRestablecer").loader("hide")

        if (respuesta.data.error) {

          swal({
            icon: "info",
            title: respuesta.data.error,
            button: {
              text: "Aceptar",
              closeModal: true,
            },
          })
          return
        }
        $("#modalRestablecerAcceso form")[0].reset()
        $("#modalRestablecerAcceso").modal("hide")
        window.history.pushState({}, null, "/");

        swal({
          icon: "success",
          title: "Se ha actualizado tu contraseña",
          button: {
            text: "Aceptar",
            closeModal: true,
          },
        }).finally(() => {
          location.reload()
        })

      })
      .catch((error) => {
        ReportErrorLog(error)
        console.error(error)
        $("#btnRestablecer").loader("hide")
        swal({
          icon: "warning",
          title: "Ocurrió un error inesperado",
          button: {
            text: "Aceptar",
            closeModal: true,
          },
        })
      })

  })


});
